export const isNewVersion = shippingVersion =>
  shippingVersion >= parseInt(process.env.REACT_APP_PAGE_MINIMUM_VERSION);
